var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('BannerHome'),_c('InfoHome'),_c('ProgramacaoHome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }